import * as React from 'react';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import OofMailtip from '../components/OofMailtip';
import type { RecipientMailtipInfo } from '../components/SingleRecipientAutomaticReplyDetails';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type MailTipDetails from '../store/schema/MailTipDetails';
import { InfoMailtipAutomaticReplyMultiple } from '../components/OofMailtip.locstring.json';
import { InfoMailtipAutomaticReply } from '../components/SingleRecipientAutomaticReplyDetails.locstring.json';
import loc, { format } from 'owa-localize';

/**
 * returns InfoBarMessageViewState for automatic replies in case one or more recipients are sending automatic replies.
 * returns null if no user is sending an automatic reply.
 */
export default (
    automaticReplyInfos: MailTipDetails[],
    onRemove?: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!automaticReplyInfos.length) {
        return null;
    }

    const recipientsInfo: RecipientMailtipInfo[] = automaticReplyInfos.map(automaticReplyInfo => ({
        recipient: automaticReplyInfo.recipient,
        automaticReply: automaticReplyInfo.message,
    }));

    return {
        key: 'AutomaticReply',
        message:
            recipientsInfo.length == 1
                ? format(
                      InfoMailtipAutomaticReply,
                      recipientsInfo[0].recipient.Name,
                      recipientsInfo[0].automaticReply
                  )
                : loc(InfoMailtipAutomaticReplyMultiple),
        messageElement: <OofMailtip recipientsInfo={recipientsInfo} onRemove={onRemove} />,
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};
